import React from 'react';
import './../../css/CardRedirection.css'
import {connect} from 'react-redux';
import {getMerchantData,onServerError} from './../../constants/merchantData';
import {OnTryAgainPageLoad, OnTryAgainPageCancel} from './../../components/SiteCat/SiteCat'

class TryLinkingAgain extends React.Component{

  constructor() {
    super();

    this.state = {
      merchantName:"",
      authCode:"" 
    };
  }

  componentWillMount = () => {
    this.setState({
      merchantName : this.props.lockedposts.merchant,
      authCode : this.props.lockedposts.authcode
    });
  }

  componentDidMount() {
    OnTryAgainPageLoad(this.state.merchantName)
    const cancelUrlData = this.props.lockedposts.cancelUrl ;
    this.setState({
      cancelUrlData
    });
  }

  handleCancel = event => {
    OnTryAgainPageCancel(this.state.merchantName)
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrlData,
      authCode: this.state.authCode 
    }
    onServerError(data);
  }

  render() {
    const merchantData = getMerchantData(this.state.merchantName)
    return(
      <React.Fragment>
        <div className="row">
          <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div className="try-again-header">{merchantData.TryLinkingAgain.HEADER}</div>
            <div className="try-again-section">{merchantData.TryLinkingAgain.MESSAGE}</div>
            <div className="try-again-link"><button class="changebtnproperty" onClick={this.handleCancel}>{merchantData.TryLinkingAgain.LINK}</button></div>
          </div>
        </div>
        </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lockedposts: state
  }
}

export default connect(mapStateToProps)(TryLinkingAgain);
